import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@babackapp/customer-ui/components/alert-dialog";
import { Button } from "@babackapp/customer-ui/components/button";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { usePublicCancelReturnRequest } from "@babackapp/private-api-client/client/use-public-cancel-return-request";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useWidgetParams } from "../../hooks/use-widget-params";

type Props = {
  returnRequestId: string;
};

export function CancelReturnSection({ returnRequestId }: Props) {
  const t = useCustomText();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { orderId, shopSlug } = useWidgetParams();
  const { mutate, isPending } = usePublicCancelReturnRequest();

  const handleConfirm = () => {
    mutate(
      { returnRequestId },
      {
        onSuccess: async () => {
          await queryClient.refetchQueries({
            predicate: (query) => {
              const key = query.queryKey;
              return key[0] === "get" && key[1] === "/public/return-request/search";
            },
          });
          navigate("../cancel-complete", { replace: true });
        },
      },
    );
  };

  return (
    <AlertDialog>
        <AlertDialogTrigger asChild>
          {/* cancel-return-button: stable hook for merchant custom CSS (La Fée Maraboutée hides it). */}
          <Button variant="link" size="sm" className="cancel-return-button">
            {t("returnRequests.details.cancelButton")}
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              {t("returnRequests.details.cancelDialog.title")}
            </AlertDialogTitle>
            <AlertDialogDescription>
              {t("returnRequests.details.cancelDialog.description")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction
              onClick={handleConfirm}
              disabled={isPending}
              variant="destructive"
            >
              {t("returnRequests.details.cancelDialog.confirm")}
            </AlertDialogAction>
            <AlertDialogCancel disabled={isPending}>
              {t("returnRequests.details.cancelDialog.dismiss")}
            </AlertDialogCancel>
          </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  );
}
